function codeToSelectData(codeList) {
  let selectData = [];
  codeList.forEach(code => {
    selectData.push({ ...code, text: code.codeNm, value: code.code });
  });
  return selectData;
}

function getCodeNm(codeList, code) {
  let codeNm = '';
  codeList.forEach(obj => {
    if (obj.code === code) {
      codeNm = obj.codeNm;
      return false;
    }
  });
  return codeNm;
}

function getCodeObj(codeList, code) {
  let codeObj = {};
  codeList.forEach(obj => {
    if (obj.code === code) {
      codeObj = obj;
      return false;
    }
  });
  return codeObj;
}

export { codeToSelectData, getCodeNm, getCodeObj };
